<template>
  <div>
    <Navbar
      :user="user"
      :device="device"
      @logout="logout"
    />
  </div>
</template>
<script>
import Navbar from './Navbar/index.vue';

export default {
  name: 'SidebarMenu',
  components: {
    Navbar
  },
  props: {
    device: {
      type: String,
      required: 'desktop'
    }
  },
  computed: {
    user() {
      const storeUser = this.$store?.state?.auth?.userInfo?.userData;
      if (storeUser && storeUser.first_name) return storeUser;
      try {
        return JSON.parse(localStorage.getItem('userData')) || { first_name: '', last_name: '', photo: '' };
      } catch {
        return { first_name: '', last_name: '', photo: '' };
      }
    }
  },
  methods: {
    logout() {
      this.$emit("logout")
    }
  }
};
</script>
